import { render, staticRenderFns } from "./manage.vue?vue&type=template&id=8ea8061e&scoped=true"
import script from "./manage.vue?vue&type=script&lang=js"
export * from "./manage.vue?vue&type=script&lang=js"
import style0 from "./manage.vue?vue&type=style&index=0&id=8ea8061e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ea8061e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8ea8061e')) {
      api.createRecord('8ea8061e', component.options)
    } else {
      api.reload('8ea8061e', component.options)
    }
    module.hot.accept("./manage.vue?vue&type=template&id=8ea8061e&scoped=true", function () {
      api.rerender('8ea8061e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/administration/material/fixed/manage.vue"
export default component.exports